(function () {
    'use strict';

    angular
        .module('franchisee-portal.components')
        .controller('HelpdeskListController', HelpdeskListController);

    /** @ngInject */
    function HelpdeskListController($scope, $q, $state, $stateParams, $rootScope, HelpdeskService, AuthenticationService, HelperService, DATA_EVENTS) {
        const vm = this;

        let ticketsPerPage;
        let ticketsSkip;
        let forcePaginationReset;
        let isTableSearch;

        vm.isSearchDisabled = () => {
            if (vm.selectedCategory || vm.selectedStatus || vm.datePicker.date.startDate || vm.searchText)
                return false;

            return true;
        }

        vm.isClearDisabled = () => {
            if (isTableSearch)
                return false;

            if (vm.selectedCategory || vm.selectedStatus || vm.datePicker.date.startDate || vm.searchText)
                return false;

            return true;
        }

        vm.doSearch = (event, isFromButton) => {
            if ((event && event.keyCode == 13) || isFromButton) {
                forcePaginationReset = true;
                isTableSearch = true;

                vm.getPaginatedTickets({
                    page: vm.currentPage
                });
            }
        }

        vm.clearSearch = () => {
            vm.searchText = null;
            vm.selectedCategory = null;
            vm.selectedStatus = null;
            vm.datePicker.date.startDate = null;
            vm.datePicker.date.endDate = null;

            isTableSearch = false;

            vm.getPaginatedTickets({
                page: vm.currentPage
            });
        }

        vm.getPaginatedTickets = pageData => {
            if (vm.isLoading)
                return;

            if (forcePaginationReset)
                vm.currentPage = 1;
            else
                vm.currentPage = pageData.page;

            ticketsSkip = (vm.currentPage - 1) * ticketsPerPage;

            getTickets();
        }

        vm.userHasTicketPermission = () => {
            const person = AuthenticationService.getUserData();

            if (!person.Responsibility)
                return;

            return person.Responsibility.Id != 4;
        }

        vm.getSlaProgress = ticket => {
            const ticketCategorySla = ticket.TicketCategory.SLA;
            const ticketSla = ticket.SLA;

            let slaProgress = ((ticketSla * 100) / ticketCategorySla).toFixed(2);

            if (slaProgress > 100)
                slaProgress = 100;

            return slaProgress;
        }

        vm.getAnswerTimeClass = ticket => {
            let timeClass;

            if (ticket < 33.3)
                timeClass = 'progress-success';
            else if (ticket < 66.6)
                timeClass = 'progress-warning';
            else
                timeClass = 'progress-danger';

            return timeClass;
        }

        let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
            init();
        })

        $scope.$on('$destroy', () => {
            removeWatchUnit();
        })

        init();

        function getTickets() {
            HelperService.startLoading('.tickets-holder');
            HelperService.startLoading('.card');

            vm.tickets = [];
            vm.isLoading = true;

            let parameters = prepareParameters();
            let personId = AuthenticationService.getUserId();

            HelpdeskService
                .getAllByParameters(parameters, personId)
                .then(success => {
                    vm.tickets = success.Ticket;

                    for (let i = 0; i < vm.tickets.length; i++) {
                        const ticket = vm.tickets[i];
                        const timelineList = ticket.TicketTimeline;

                        timelineList.sort((a, b) => {
                            return new Date(a.RegistrationDate) - new Date(b.RegistrationDate);
                        }).reverse();

                        ticket.LastResponse = timelineList[0];
                    }

                    vm.numberOfPages = success.NumberOfPages;
                    vm.numberOfTickets = success.NumberOfTickets;
                    vm.numberOfTicketsOpened = success.NumberOfTicketsOpened;
                    vm.numberOfTicketsClosed = success.NumberOfTicketsClosed;
                    vm.isLoading = false;

                    $state.go('app-master.default.helpdesk', {
                        helpdeskPage: vm.currentPage
                    });

                    HelperService.stopLoading('.tickets-holder');
                    HelperService.stopLoading('.card');
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function getCategories() {
            return HelpdeskService
                .getAllCategories()
                .then(
                    success => {
                        vm.categories = success.filter(category => category.Id != 2);

                        HelperService.stopLoading('.page-filter');
                    },
                    error => {
                        HelperService.errorCallback(error);
                        HelperService.stopLoading('.page-filter');
                    });
        }

        function getStatus() {
            return HelpdeskService
                .getAllStatus()
                .then(
                    success => vm.status = success,
                    error => HelperService.errorCallback(error)
                );
        }

        function prepareParameters() {
            let params = {
                PerPage: ticketsPerPage,
                Skip: ticketsSkip,
                OrderBy: 'RegistrationDate',
                OrderDescending: true,
                GetIndicators: true
            }

            if (vm.selectedCategory)
                params.TicketCategoryId = vm.selectedCategory.Id;

            if (vm.selectedStatus)
                params.TicketStatusId = vm.selectedStatus.Id;

            if (vm.datePicker.date.startDate) {
                params.StartDate = vm.datePicker.date.startDate.format('YYYY-MM-DD');
                params.EndDate = vm.datePicker.date.endDate.format('YYYY-MM-DD');
            }

            if (vm.searchText) {
                params.SearchField = 'Title';
                params.SearchQuery = vm.searchText;
            }

            return params;
        }

        function initVars() {
            ticketsPerPage = 5;
            ticketsSkip = 0;
            forcePaginationReset = false;
            isTableSearch = false;

            vm.currentPage = 1;
            vm.numberOfPages = 0;

            if (isNaN($stateParams.helpdeskPage)) {
                $state.go('app-master.default.helpdesk', {
                    helpdeskPage: 1
                });
            } else
                vm.currentPage = $stateParams.helpdeskPage;

            vm.tickets = [];
            vm.isLoading = false;

            vm.currentHelpdesk = "Meus Chamados";

            vm.datePicker = {
                date: {
                    startDate: null,
                    endDate: null
                },
                options: {
                    'opens': 'left',
                    'maxDate': moment(),
                    'timePicker': false,
                    'format': 'DD/MM/YYYY',
                    'ranges': {
                        'Hoje': [
                            moment(),
                            moment()
                        ],
                        'Ontem': [
                            moment().subtract(1, 'days'),
                            moment().subtract(1, 'days')
                        ],
                        '7 Dias': [
                            moment().subtract(7, 'days'),
                            moment()
                        ],
                        '15 Dias': [
                            moment().subtract(15, 'days'),
                            moment()
                        ],
                        '30 Dias': [
                            moment().subtract(30, 'days'),
                            moment()
                        ]
                    }
                }
            };

            HelperService.startLoading('.page-filter');
        }

        function init() {
            initVars();

            $q.all([getCategories(), getStatus()])
                .then(() => {
                    vm.getPaginatedTickets({
                        page: vm.currentPage
                    });
                });
        }
    }
}());